<template>
  <div class="exportShpAndText">
    <div class="titleInfo">
      <div class="left"><i class="iconfont icon-shuxian"></i>导出数据</div>
      <div class="right">
        <i class="iconfont icon-guanbi" @click="closeLayer"></i>
      </div>
    </div>
    <div class="contentCal">
      <Form ref="form">
        <FormItem type="flex" label="选择绘制方式：" prop="drawType">
          <div class="btnstyle">
            <Row>
              <Col span="4">
                <div class="iconstyle" @click="drawArea('Point')">
                  <img src="../../../static/image/analysis/点/point_un.png" />
                  <div class="text">点</div>
                </div>
              </Col>
              <Col span="4">
                <div class="iconstyle" @click="drawArea('LineString')">
                  <img src="../../../static/image/analysis/线/line_un.png" />
                  <div class="text">线</div>
                </div>
              </Col>
              <Col span="5">
                <div class="iconstyle" @click="drawArea('Box')">
                  <img src="../../../static/image/analysis/面/fill_un.png" />
                  <div class="text">面</div>
                </div>
              </Col>
              <Col span="5">
                <div class="iconstyle" @click="drawArea('Polygon')">
                  <img src="../../../static/image/analysis/异形/poly_un.png" />
                  <div class="text">异形</div>
                </div>
              </Col>
              <Col span="5">
                <div class="iconstyle" @click="drawArea('delete')">
                  <img src="../../../static/image/analysis/删除/del_un.png" />
                  <div class="text">清除</div>
                </div>
              </Col>
            </Row>
          </div>
        </FormItem>
        <FormItem type="flex" label="导出方式：" prop="drawType">
          <div class="btnstyle">
            <Row>
              <Col span="24">
                <RadioGroup v-model="exportType">
                  <Radio label="shp">shp</Radio>
                  <Radio label="text">text(wkt)</Radio>
                  <Radio label="partCoordinates">部坐标</Radio>
                </RadioGroup>
              </Col>
            </Row>
          </div>
        </FormItem>
      </Form>
    </div>
    <div class="footerCal">
      <div class="oncheck">
        <Button type="primary" @click.stop="handleOk" :loading="outputLoading">导出</Button>
        <Button class="infoclose" @click.stop="handleCancel">关闭</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { postExportShpOrtext } from '@/api/index.js';
export default {
  name: 'exportShpAndText',
  data() {
    return {
      outputLoading: false,
      exportType: 'shp',
      currentGeometryType: '',
      gridDrawLayer: null,
      gridDraws: null,
      drawGrid: {
        polygonWKT: '',
        polygonJson: [],
        feature: null,
        currentGeometryType: '',
      },
      drawGridArr: [],
      gridDrawLayerArr: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 绘制的方法
    drawArea(type) {
      var _this = this;
      this.olmap.drawOpt = true;
      if (type == 'delete' && this.gridDraws) {
        this.clearDraw();
        return;
      }
      switch (type) {
        case 'Circle':
        case 'Box':
        case 'Polygon':
          this.currentGeometryType = 'POLYGON';
          break;
        case 'LineString':
          this.currentGeometryType = 'LINESTRING';
          break;
        case 'Point':
          this.currentGeometryType = 'POINT';
          break;
      }
      this.initDraw(type);
      this.olmap.addInteraction(this.gridDraws);
      this.gridDrawLayer.getSource().on('addfeature', function(event) {});
      // 返回绘制的结果；
      this.drawGridCopy = JSON.parse(JSON.stringify(this.drawGrid));
      this.gridDraws.on('drawend', function(evt) {
        var geometry = evt.feature.getGeometry();
        _this.drawGridCopy.polygonWKT = new _this.$olmap.format.WKT().writeGeometry(
          evt.feature.getGeometry(),
          {}
        );
        _this.drawGridCopy.polygonJson = geometry.getCoordinates();
        _this.drawGridCopy.currentGeometryType = _this.currentGeometryType;
        _this.drawGridArr.push(_this.drawGridCopy); //所有的绘制的集合；
        _this.olmap.removeInteraction(_this.gridDraws);
      });
    },
    // 初始化绘制的方式
    initDraw(type, datasource) {
      //实例化一个矢量图层Vector作为绘制层
      if (this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
      }
      var result = this.publicMethod.initDrawC(type, datasource); //通用封装方法
      this.gridDraws = result.gridDraws;
      this.gridDrawLayer = result.gridDrawLayer;
      this.gridDrawLayerArr.push(this.gridDrawLayer);
      this.olmap.addLayer(this.gridDrawLayer);
    },
    // 点击关闭弹框的按钮
    closeLayer() {
      this.clearDraw();
      this.$emit('closeLayer');
    },
    clearDraw() {
      this.olmap.drawOpt = false;
      if (this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
      }
      // 移除绘制的数据
      if (this.gridDrawLayer) {
        this.gridDrawLayer.getSource().clear();
        this.gridDrawLayerArr.forEach((item, index) => {
          this.olmap.removeLayer(item);
        });
        this.gridDrawLayerArr = [];
        this.drawGridArr = [];
      }
    },
    // 点击关闭的按钮
    handleCancel() {
      this.clearDraw();
      this.$emit('closeLayer');
    },
    // 点击导出的按钮
    handleOk() {
      this.outputLoading = true;
      if (this.drawGridArr.length === 0) {
        this.$Message.info('请先绘制，在进行导出!');
        this.outputLoading = false;
        return;
      }
      var param = {
        type: this.exportType,
        jsonArr: JSON.stringify(this.drawGridArr),
      };
      postExportShpOrtext(param).then(res => {
        if (res) {
          this.outputLoading = false;
          var blob = new Blob([res], {
            type:
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8',
          });
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          var $a = $('<a></a>')
            .attr('href', href)
            .attr('download', `导出${this.exportType}.zip`); //下载
          $a[0].click();
        }
      });
    },
  },
  beforeDestroy() {
    this.clearDraw();
  },
};
</script>

<style lang="less" scoped>
.exportShpAndText {
  position: absolute;
  top: 50px;
  right: 18px;
  z-index: 900;
  width: 300px;
  height: 320px;
  border-radius: 5px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  .titleInfo {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    .icon-shuxian {
      color: #0099fa;
    }
    .left {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
    }
    .right {
      line-height: 40px;
      cursor: pointer;
      .icon-guanbi {
        font-size: 30px;
      }
    }
  }
  .contentCal {
    width: 100%;
    padding: 10px;
    flex: 1;
    .btnstyle {
      padding-left: 20px;
      .iconstyle {
        display: flex;
        justify-content: flex-start;
        cursor: pointer;
        height: 20px;
        img {
          display: inline-block;
          text-align: center;
        }
        .text {
          text-align: center;
          font-size: 12px;
          width: 30px;
          line-height: 20px;
        }
      }
    }
  }
  .footerCal {
    width: 100%;
    height: 55px;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    padding-top: 10px;
    .oncheck {
      .infoclose {
        margin-left: 10px;
        margin-right: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/maptools/exportShpAndText.vue